'use client';

import CompanySizeIcon from './CompanySize.js';
import LocationIcon from './Location.js';
import EducationIcon from './Education.js';
import PhoneNumberIcon from './PhoneNumber.js';
import CalendarIOS16GlyphICon from './CalendarIOS16Glyph.js';
import AdminIcon from './Admin.js';
import HeadHunterIcon from './HeadHunter.js';
import AddressIcon from './Address.js';
import SalaryIcon from './Salary.js';
import GenderIcon from './Gender.js';
import TranslatorIcon from './Translator.js';
import BirthdayIcon from './Birthday.js';
import LocationIOS16GlyphIcon from './LocationIOS16Glyph.js';
import CreditIcon from './CreditIcon.js';

var InfoOverview = {
    CompanySizeIcon: CompanySizeIcon,
    LocationIcon: LocationIcon,
    EducationIcon: EducationIcon,
    PhoneNumberIcon: PhoneNumberIcon,
    CalendarIOS16GlyphICon: CalendarIOS16GlyphICon,
    AdminIcon: AdminIcon,
    HeadHunterIcon: HeadHunterIcon,
    SalaryIcon: SalaryIcon,
    AddressIcon: AddressIcon,
    GenderIcon: GenderIcon,
    TranslatorIcon: TranslatorIcon,
    BirthdayIcon: BirthdayIcon,
    LocationIOS16GlyphIcon: LocationIOS16GlyphIcon,
    CreditIcon: CreditIcon
};

export { InfoOverview as default };
//# sourceMappingURL=index.js.map
